import styled from 'styled-components'

import { baseSelectStyles } from './NativeSelect.styles'
import { withFlex } from '@sketch/components'

const SelectButton = styled(withFlex('button'))`
  ${baseSelectStyles};
  /*
    baseSelectStyles is overwriting the display: flex from withFlex() so we need
    to re-define it
  */
  display: flex;
  align-items: center;
`
export default SelectButton
